/* Część 2: wysokość paska sezonu pod przyklejoną belką, dolny pasek na telefonie po zjeździe z góry
   i link „Wybierz voucher” do wybranej kwoty (wariant produktu). */
(function () {
  var d = document, ps = d.querySelector('.pasek-sezon');
  function h() { d.documentElement.style.setProperty('--n-ph', (ps ? ps.offsetHeight : 0) + 'px'); }
  h(); addEventListener('resize', h);
  function sc() { d.body.classList.toggle('n-past', scrollY > 320); }
  sc(); addEventListener('scroll', sc, { passive: true });
  d.addEventListener('click', function (e) {
    var c = e.target.closest('[data-ng-url]'); if (!c) return;
    var s = c.closest('.ng'), cta = s && s.querySelector('[data-ng-cta]');
    if (cta) cta.href = c.getAttribute('data-ng-url');
  });
})();
